import { render, staticRenderFns } from "./CourseViewPanel.vue?vue&type=template&id=3c51c819"
import script from "./CourseViewPanel.vue?vue&type=script&lang=js"
export * from "./CourseViewPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports